module.exports = __webpack_public_path__ + "img/icon-user-plus.b8823c7e.svg";